import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/video player.svg` */
export const VideoPlayerIcon = createTripletGlyphIcon('VideoPlayerIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.30762 5.39941C5.31152 4.816 5.94635 4.45493 6.4502 4.74902L10.918 7.36035L11.0068 7.4209C11.3921 7.72337 11.3888 8.31684 11 8.61523L10.9111 8.67383L6.41406 11.2393C5.90667 11.5286 5.27518 11.1601 5.27832 10.5762L5.30762 5.39941ZM6.38281 9.99023L9.85352 8.01172L6.40527 5.99707L6.38281 9.99023Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7432 2.47852C13.7832 2.47852 14.6268 3.32134 14.627 4.36133V11.6387C14.6268 12.6787 13.7832 13.5225 12.7432 13.5225H3.25586C2.21606 13.5222 1.37321 12.6785 1.37305 11.6387V4.36133C1.37322 3.32151 2.21607 2.47879 3.25586 2.47852H12.7432ZM3.25586 3.57812C2.82358 3.5784 2.47283 3.92902 2.47266 4.36133V11.6387C2.47282 12.071 2.82357 12.4226 3.25586 12.4229H12.7432C13.1757 12.4229 13.5262 12.0712 13.5264 11.6387V4.36133C13.5262 3.92885 13.1757 3.57812 12.7432 3.57812H3.25586Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.04004 6.0752C6.04377 5.47132 6.70032 5.09764 7.22168 5.40234L12.248 8.33984L12.3398 8.40234C12.7384 8.71518 12.7351 9.329 12.333 9.6377L12.2402 9.69922L7.18164 12.584C6.65674 12.8833 6.00342 12.5026 6.00684 11.8984L6.04004 6.0752ZM7.11133 11.3584L11.2217 9.01367L7.1377 6.62695L7.11133 11.3584Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3359 2.85645C15.468 2.85645 16.3856 3.77418 16.3857 4.90625V13.0938C16.3855 14.2258 15.468 15.1436 14.3359 15.1436H3.66309C2.5312 15.1434 1.6135 14.2256 1.61328 13.0938V4.90625C1.61341 3.7743 2.53115 2.85664 3.66309 2.85645H14.3359ZM3.66309 3.95605C3.13866 3.95625 2.71302 4.38181 2.71289 4.90625V13.0938C2.71311 13.6181 3.13872 14.0428 3.66309 14.043H14.3359C14.8605 14.043 15.2859 13.6182 15.2861 13.0938V4.90625C15.286 4.38169 14.8605 3.95605 14.3359 3.95605H3.66309Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.03809 8.10059C8.04287 7.28237 8.93137 6.77567 9.6377 7.18848L16.3389 11.1055L16.4639 11.1895C17.0039 11.6133 16.9991 12.4462 16.4541 12.8643L16.3291 12.9463L9.58301 16.793C8.8721 17.1984 7.98979 16.6833 7.99414 15.8652L8.03809 8.10059ZM9.49805 15.1162L14.9287 12.0186L9.5332 8.86523L9.49805 15.1162Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1152 3.79199C20.6339 3.79212 21.8652 5.02329 21.8652 6.54199V17.458C21.8652 18.9767 20.6339 20.2079 19.1152 20.208H4.88477C3.46094 20.208 2.29028 19.1259 2.14941 17.7393L2.13477 17.458V6.54199C2.13477 5.02321 3.36598 3.79199 4.88477 3.79199H19.1152ZM4.88477 5.29199C4.19441 5.29199 3.63477 5.85164 3.63477 6.54199V17.458L3.6416 17.5859C3.70567 18.2162 4.2376 18.708 4.88477 18.708H19.1152C19.8055 18.7079 20.3652 18.1483 20.3652 17.458V6.54199C20.3652 5.85172 19.8055 5.29212 19.1152 5.29199H4.88477Z"
        fill="currentColor"
      />
    </svg>
  ),
});
